import React, { useState } from 'react';
import { Grid, Button } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import LoadingSpinner from 'src/_common/quillElements/spinner/Loading';
import { isEmail } from 'core/utils';
import getConfig from 'next/config';
import { VideoComponent } from '../VideoComponent';

const { publicRuntimeConfig } = getConfig();

const video = {
  thumbnail: './images/theme/commonImages/studentResources/thesis-cover.png',
  videoUrl: 'https://www.youtube.com/embed/T5YqaWeW9ew?rel=0',
};

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1142,
    margin: '0 auto',
    padding: '64px 16px',
  },
  heroTextWrapper: {
    margin: '0 auto',
    textAlign: 'center',
  },
  pageTitle: {
    maxWidth: 640,
    margin: '0 auto',
    fontSize: 30,
    fontWeight: 400,
    textAlign: 'center',
  },
  heroSubtext: {
    maxWidth: 528,
    margin: '24px auto 32px',
    fontSize: 16,
  },
  inputWrapper: {
    // display: 'flex',
    maxWidth: 476,
    margin: '0 auto',
    '& input': {
      backgroundColor: `${theme.palette.grey[50]} !important`,
      borderRadius: '4px !important',
      boxShadow: 'none !important',
      border: `1px solid ${theme.palette.divider} !important`,
      color: `${theme.palette.text.primary} !important`,
    },
    '& input::hover': {
      backgroundColor: `${theme.palette.grey[50]} !important`,
      outline: 'none !important',
      boxShadow: 'none !important',
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      // borderColor: `${theme.palette.grey[50]} !important`,
    },
    '& input::focus': {
      backgroundColor: `${theme.palette.grey[50]} !important`,
      outline: 'none !important',
      boxShadow: 'none !important',
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      // borderColor: `${theme.palette.primary.main} !important`,
    },
    '& input::placeholder': {
      color: `${theme.palette.text.disabled} !important`,
    },
    '& button': {
      padding: '16px !important',
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
  },
  inputEmail: {},
  submitBtn: {
    marginLeft: 16,
    fontSize: 16,
    fontWeight: 600,
    minHeight: 47,
  },
  videoWrapper: {
    marginTop: 64,
    textAlign: 'center',
  },
}));

export default function ThesisCourse() {
  const isMobile = useSelector((rootState: RootState) => rootState.common.platform.isMobile);
  const isAuthenticated = useSelector((rootState: RootState) => rootState?.user?.isAuthenticated);
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [formSubmitted, updateFormSubmitted] = useState(false);

  const setDefaultState = () => {
    updateFormSubmitted(false);
    setEmail('');
    setLoading(false);
  };

  const onEmailEnter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e?.target?.value;
    setEmail(value);
    updateFormSubmitted(false);
  };

  let emailHelperText: string | null;
  if (formSubmitted) {
    if (!email) emailHelperText = 'Required';
    else if (!isEmail(email)) emailHelperText = 'Please enter valid email';
    else emailHelperText = null;
  } else {
    emailHelperText = null;
  }

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <div className={classes.heroTextWrapper}>
            <h2 className={classes.pageTitle}>
              Feeling stuck? Register for our free Get Your Thesis Back on Track online course.
            </h2>
            <div className={classes.heroSubtext}>
              We’ll discuss the ins and outs of academic writing, navigating writing roadblocks, and
              creating a solid writing and research workflow.
            </div>
            <div className={classes.inputWrapper}>
              <div className={publicRuntimeConfig.STUDENT_RESOURCE_KLAVIO_CLASSNAME} />
            </div>
          </div>
          <div className={classes.videoWrapper}>
            <VideoComponent
              thumbnail={video.thumbnail}
              videoUrl={video.videoUrl}
              height={isMobile ? '210px' : '316px'}
              width="714px"
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
}
